export default async function initReadAloudTrigger() {
  const element = document.querySelector('[data-js-module="read-aloud-trigger"]');

  if (element) {
    const { default: ReadAloudTrigger } = await import(/* webpackChunkName: "read-aloud-trigger" */ './read-aloud-trigger');
    new ReadAloudTrigger(element);
  }
}
